const fontFamily = {
    sansSerif: `"Figtree", sans-serif`,
    serif: `"Feature Deck", "Figtree", sans-serif`,
};

export { fontFamily };
